(function ($, Drupal) {
  function replaceAnyWithAll(context) {
    $('#block-views-block-all-products-all-products .bef-link', context).each(function () {
      const $link = $(this);
      if ($link.text().trim() === '- Any -') {
        $link.text('All');
      }
    });
  }

  Drupal.behaviors.replaceAnyLabelScoped = {
    attach: function (context, settings) {
      replaceAnyWithAll(context); // Run on initial attach + each AJAX attach
    }
  };

  // Also listen to raw AJAX updates in case anything slips through
  $(document).ajaxComplete(function () {
    replaceAnyWithAll(document); // Target whole document after any AJAX completes
  });

})(jQuery, Drupal);
